// export default function DividerComponent ({ style }) {

//     return (
//             <hr style={style}/>
//     )
// };

export default function DividerComponent({ style }) {

  return (
    <table
      role="presentation"
      width="100%"
      cellPadding="0"
      cellSpacing="0"
      style={{ width: style?.width || "100%" }}
    >
      <tr>
        <td
          valign={style?.valign}
          style={{
            padding: style?.padding || "0",
          }}
        >
          {/* Horizontal line as a table element */}
          <table
            role="presentation"
            width={style?.width || "100%"}
            cellPadding="0"
            cellSpacing="0"
            style={{ width: style?.width || "100%" }}
          >
            <tr>
              <td
                style={{
                  borderTop: `${style?.thickness || "1px"} solid ${
                    style?.color || "#000000"
                  }`,
                  fontSize: "0", // prevents space in Outlook
                  lineHeight: "0",
                }}
              >
                &nbsp;
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  );
}
